/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ReportsPageQueryVariables = {};
export type ReportsPageQueryResponse = {
    readonly me: {
        readonly user: {
            readonly company: {
                readonly id: string;
                readonly name: string;
            } | null;
        } | null;
    } | null;
};
export type ReportsPageQuery = {
    readonly response: ReportsPageQueryResponse;
    readonly variables: ReportsPageQueryVariables;
};



/*
query ReportsPageQuery {
  me {
    user {
      company {
        id
        name
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Company",
  "kind": "LinkedField",
  "name": "company",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Me",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ReportsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Me",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb1e3ceac4e32836b39ede7c7a6ebe65",
    "id": null,
    "metadata": {},
    "name": "ReportsPageQuery",
    "operationKind": "query",
    "text": "query ReportsPageQuery {\n  me {\n    user {\n      company {\n        id\n        name\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c82902b0bada78bb207fa41399ffbac2';
export default node;
